module.exports = __webpack_public_path__ + "static/img/bg-remind.7a5663d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/bg-remind.jpg
// module id = CKN+
// module chunks = 0